/**
 * Shared Mailchimp-style signup forms: inline errors + submit loading state.
 */
(function (w) {
  function clearErrors(form) {
    if (!form) return;
    form.querySelectorAll('.mc-signup-fields__error').forEach(function (el) {
      el.textContent = '';
      el.hidden = true;
      el.classList.remove('is-visible');
    });
    form.querySelectorAll('.mc-signup-form-banner').forEach(function (el) {
      el.textContent = '';
      el.hidden = true;
      el.classList.remove('is-visible');
    });
    form.querySelectorAll('.mc-signup-fields__input, .mc-signup-fields__input--date').forEach(function (inp) {
      inp.removeAttribute('aria-invalid');
    });
  }

  function showFieldError(input, message) {
    if (!input || !message) return;
    var err = document.getElementById(input.id + '-error');
    if (err) {
      err.textContent = message;
      err.hidden = false;
      err.classList.add('is-visible');
    }
    input.setAttribute('aria-invalid', 'true');
  }

  function isValidEmail(value) {
    var v = (value || '').trim();
    if (!v) return false;
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  }

  /**
   * @returns {boolean} true if valid
   */
  function validate(form) {
    clearErrors(form);
    var ok = true;

    var email = form.querySelector('input[name="EMAIL"]');
    if (email) {
      var ev = (email.value || '').trim();
      if (!ev) {
        showFieldError(email, 'Please enter your email address.');
        ok = false;
      } else if (!isValidEmail(ev)) {
        showFieldError(email, 'Please enter a valid email address.');
        ok = false;
      }
    }

    var dateInput = form.querySelector('input[type="date"][data-mc-birthday]');
    if (dateInput && dateInput.value) {
      var parts = dateInput.value.split('-');
      if (parts.length !== 3) {
        showFieldError(dateInput, 'Please enter a valid date.');
        ok = false;
      } else {
        var y = parseInt(parts[0], 10);
        var m = parseInt(parts[1], 10);
        var d = parseInt(parts[2], 10);
        var dt = new Date(y, m - 1, d);
        if (
          dt.getFullYear() !== y ||
          dt.getMonth() !== m - 1 ||
          dt.getDate() !== d ||
          y < 1900 ||
          y > new Date().getFullYear()
        ) {
          showFieldError(dateInput, 'Please enter a valid date.');
          ok = false;
        }
      }
    }

    var fname = form.querySelector('input[name="FNAME"]');
    if (fname && fname.value.length > 80) {
      showFieldError(fname, 'First name is too long (max 80 characters).');
      ok = false;
    }
    var lname = form.querySelector('input[name="LNAME"]');
    if (lname && lname.value.length > 80) {
      showFieldError(lname, 'Last name is too long (max 80 characters).');
      ok = false;
    }

    return ok;
  }

  function setLoading(form, loading, submitBtn, loadingText) {
    if (!form) return;
    submitBtn = submitBtn || form.querySelector('button[type="submit"]');
    if (!submitBtn) return;

    if (loading) {
      if (submitBtn.dataset.mcOriginalLabel === undefined) {
        submitBtn.dataset.mcOriginalLabel = submitBtn.textContent.trim();
      }
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-busy', 'true');
      submitBtn.classList.add('is-loading');
      form.classList.add('is-submitting');
      var label = loadingText || submitBtn.dataset.loadingText || 'Submitting…';
      submitBtn.textContent = label;
    } else {
      submitBtn.disabled = false;
      submitBtn.removeAttribute('aria-busy');
      submitBtn.classList.remove('is-loading');
      form.classList.remove('is-submitting');
      if (submitBtn.dataset.mcOriginalLabel !== undefined) {
        submitBtn.textContent = submitBtn.dataset.mcOriginalLabel;
        delete submitBtn.dataset.mcOriginalLabel;
      }
    }
  }

  function bindClearOnInput(form) {
    if (!form || form.dataset.mcClearBound) return;
    form.dataset.mcClearBound = 'true';
    form.addEventListener(
      'input',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        if (!form.contains(t)) return;
        if (t.matches && t.matches('input.mc-signup-fields__input, input.mc-signup-fields__input--date')) {
          var err = document.getElementById(t.id + '-error');
          if (err && err.classList.contains('is-visible')) {
            err.textContent = '';
            err.hidden = true;
            err.classList.remove('is-visible');
          }
          t.removeAttribute('aria-invalid');
        }
      },
      true
    );
  }

  w.McSignupForm = {
    clearErrors: clearErrors,
    validate: validate,
    setLoading: setLoading,
    bindClearOnInput: bindClearOnInput
  };
})(window);
